import { createContext } from 'react'

const auctionPayContext = createContext()

export default auctionPayContext
